import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeNumericWithSlider } from '../traitTypes/TraitTypeNumericWithSlider';
export class TraitRegistryAspectDraggable extends TraitRegistryCategory {
    label = 'Draggable';
    constructor(parent) {
        super(parent);
        super.init();
    }
    draggableDefaultX = () => new TraitTypeNumericWithSlider({
        /*  label: 'DraggableDefaultX →',
          min: 0,
          max: 1000, */
        roundDecimals: 0
    });
    draggableDefaultY = () => new TraitTypeNumericWithSlider({
        /*     label: 'DraggableDefaultY ↓',
             min: 0,
             max: 1000, */
        roundDecimals: 0
    });
    draggableX = () => new TraitTypeNumericWithSlider({
        /*   label: 'DraggableX →',
           min: 0,
           max: 1000, */
        roundDecimals: 0
    });
    draggableY = () => new TraitTypeNumericWithSlider({
        /*   label: 'DraggableY ↓',
           min: 0,
           max: 1000, */
        roundDecimals: 0
    });
}
